// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html:has(body.scanning) {
  background: transparent !important;
}
.scanning {
  background: transparent !important;
}
.scanning .splash-screen {
  opacity: 0;
}
.scanning .chakra-screen-content {
  background: transparent !important;
  opacity: 0;
}
.scanning .chakra-waiting-overlay {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pos/css/scanning.less"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE,UAAU;AACZ","sourcesContent":["html:has(body.scanning) {\n  background: transparent !important;\n}\n.scanning {\n  background: transparent !important;\n}\n.scanning .splash-screen {\n  opacity: 0;\n}\n.scanning .chakra-screen-content {\n  background: transparent !important;\n  opacity: 0;\n}\n.scanning .chakra-waiting-overlay {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
